"use client"

import { BundleSelector } from "~/components/ui/Product/ProductHeader/ProductDetails/BundleSelector/index.client"
import { objectValues } from "~/utils/object-values"
import type { BundleSelectorWithVariantSwitchProps } from "~/app/[locale]/products/[slug]/_components/BundleSelectorWithVariantSwitch"
import { useVariantSwitch } from "~/app/[locale]/products/[slug]/_hooks/use-variant-switch"

function ClientBundleSelectorWithVariantSwitch({
  className,
  productHeader,
  children,
}: BundleSelectorWithVariantSwitchProps) {
  const { currentOptions, setCurrentOptions } = useVariantSwitch({
    defaultOptions: objectValues(productHeader?.defaultBundleOptions),
  })

  return currentOptions ? (
    <BundleSelector
      className={className}
      currentOptions={currentOptions}
      setCurrentOptions={setCurrentOptions}
      productHeader={productHeader}
    >
      {children}
    </BundleSelector>
  ) : null
}

export default ClientBundleSelectorWithVariantSwitch
